import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import keygenrerationReducer from "../src/store/keygenreration/slice";
import enterprisesReducer from "../src/store/enterprise/slice";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, keygenrerationReducer);

const store = configureStore({
  reducer: {
    keygenreration: persistedReducer,
    enterprises: enterprisesReducer,
  },
});

const persistor = persistStore(store);

export { store, persistor };
